import { useItemsListHelpers } from "@/components/ListingPages/ItemsLister/composables/itemsListHelpers/itemsListHelpers";
import itemsListerConfig from './config/itemsLister.config';

const {
  apiPathsConfig,
  filtersDisplayConfig,
  isEnableAllLimitOption,
  entityItemsNamePlural,
  entityItemName
} = itemsListerConfig;

function usePlayersListHelpers() {
  return useItemsListHelpers({
    apiPathsConfig,
    filtersDisplayConfig,
    isEnableAllLimitOption,
    entityItemsNamePlural,
    entityItemName
  })
}


export default usePlayersListHelpers;